/* constituencyData.js
   Mapping of Tamil Nadu Assembly Constituency Numbers to Districts.
   Based on 2008 delimitation.
*/

export const constituencyToDistrict = {
  1: "Thiruvallur",
  2: "Thiruvallur",
  3: "Thiruvallur",
  4: "Thiruvallur",
  5: "Thiruvallur",
  6: "Thiruvallur",
  7: "Chennai",
  8: "Chennai",
  9: "Thiruvallur",
  10: "Chennai",
  11: "Chennai",
  12: "Chennai",
  13: "Chennai",
  14: "Chennai",
  15: "Chennai",
  16: "Chennai",
  17: "Chennai",
  18: "Chennai",
  19: "Chennai",
  20: "Chennai",
  21: "Chennai",
  22: "Chennai",
  23: "Chennai",
  24: "Chennai",
  25: "Chennai",
  26: "Chennai",
  27: "Chennai",
  28: "Kancheepuram",
  29: "Kancheepuram",
  30: "Chengalpattu",
  31: "Chengalpattu",
  32: "Chengalpattu",
  33: "Chengalpattu",
  34: "Chengalpattu",
  35: "Chengalpattu",
  36: "Kancheepuram",
  37: "Kancheepuram",
  38: "Ranipet",
  39: "Ranipet",
  40: "Ranipet",
  41: "Ranipet",
  42: "Ranipet",
  43: "Ranipet",
  44: "Vellore",
  45: "Vellore",
  46: "Vellore",
  47: "Tirupattur",
  48: "Tirupattur",
  49: "Tirupattur",
  50: "Tirupattur",
  51: "Krishnagiri",
  52: "Krishnagiri",
  53: "Krishnagiri",
  54: "Krishnagiri",
  55: "Krishnagiri",
  56: "Krishnagiri",
  57: "Dharmapuri",
  58: "Dharmapuri",
  59: "Dharmapuri",
  60: "Dharmapuri",
  61: "Dharmapuri",
  62: "Tiruvannamalai",
  63: "Tiruvannamalai",
  64: "Tiruvannamalai",
  65: "Tiruvannamalai",
  66: "Tiruvannamalai",
  67: "Tiruvannamalai",
  68: "Tiruvannamalai",
  69: "Tiruvannamalai",
  70: "Villupuram",
  71: "Villupuram",
  72: "Villupuram",
  73: "Villupuram",
  74: "Villupuram",
  75: "Villupuram",
  76: "Villupuram",
  77: "Kallakurichi",
  78: "Kallakurichi",
  79: "Kallakurichi",
  80: "Kallakurichi",
  81: "Salem",
  82: "Salem",
  83: "Salem",
  84: "Salem",
  85: "Salem",
  86: "Salem",
  87: "Salem",
  88: "Salem",
  89: "Salem",
  90: "Salem",
  91: "Salem",
  92: "Namakkal",
  93: "Namakkal",
  94: "Namakkal",
  95: "Namakkal",
  96: "Namakkal",
  97: "Namakkal",
  98: "Erode",
  99: "Erode",
  100: "Erode",
  101: "Tiruppur", // Dharapuram is in Tiruppur dist
  102: "Tiruppur", // Kangayam
  103: "Erode", // Perundurai
  104: "Erode", // Bhavani
  105: "Erode", // Anthiyur
  106: "Erode", // Gobichettipalayam
  107: "Erode", // Bhavanisagar
  108: "The Nilgiris", // Udhagamandalam
  109: "The Nilgiris", // Gudalur
  110: "The Nilgiris", // Coonoor
  111: "Coimbatore", // Mettupalayam
  112: "Tiruppur", // Avinashi
  113: "Tiruppur", // Tiruppur North
  114: "Tiruppur", // Tiruppur South
  115: "Tiruppur", // Palladam
  116: "Coimbatore", // Sulur
  117: "Coimbatore", // Kavundampalayam
  118: "Coimbatore", // Coimbatore North
  119: "Coimbatore", // Thondamuthur
  120: "Coimbatore", // Coimbatore South
  121: "Coimbatore", // Singanallur
  122: "Coimbatore", // Kinathukadavu
  123: "Coimbatore", // Pollachi
  124: "Coimbatore", // Valparai
  125: "Tiruppur", // Udumalpet
  126: "Tiruppur", // Madathukulam
  127: "Dindigul", // Palani
  128: "Dindigul", // Oddanchatram
  129: "Dindigul", // Athoor
  130: "Dindigul", // Nilakkottai
  131: "Dindigul", // Natham
  132: "Dindigul", // Dindigul
  133: "Dindigul", // Vedasandur
  134: "Karur", // Aravakurichi
  135: "Karur", // Karur
  136: "Karur", // Krishnarayapuram
  137: "Karur", // Kulithalai
  138: "Tiruchirappalli", // Manapparai
  139: "Tiruchirappalli", // Srirangam
  140: "Tiruchirappalli", // Tiruchirappalli West
  141: "Tiruchirappalli", // Tiruchirappalli East
  142: "Tiruchirappalli", // Thiruverumbur
  143: "Tiruchirappalli", // Lalgudi
  144: "Tiruchirappalli", // Manachanallur
  145: "Tiruchirappalli", // Musiri
  146: "Tiruchirappalli", // Thuraiyur
  147: "Perambalur", // Perambalur
  148: "Perambalur", // Kunnam
  149: "Ariyalur", // Ariyalur
  150: "Ariyalur", // Jayankondam
  151: "Cuddalore", // Tittakudi
  152: "Cuddalore", // Vridhachalam
  153: "Cuddalore", // Neyveli
  154: "Cuddalore", // Panruti
  155: "Cuddalore", // Cuddalore
  156: "Cuddalore", // Kurinjipadi
  157: "Cuddalore", // Bhuvanagiri
  158: "Cuddalore", // Chidambaram
  159: "Cuddalore", // Kattumannarkoil
  160: "Mayiladuthurai", // Sirkali
  161: "Mayiladuthurai", // Mayiladuthurai
  162: "Mayiladuthurai", // Poompuhar
  163: "Nagapattinam", // Nagapattinam
  164: "Nagapattinam", // Kilvelur
  165: "Nagapattinam", // Vedaranyam
  166: "Tiruvarur", // Thiruthuraipoondi
  167: "Tiruvarur", // Mannargudi
  168: "Tiruvarur", // Tiruvarur
  169: "Tiruvarur", // Nannilam
  170: "Thanjavur", // Thiruvidaimarudur
  171: "Thanjavur", // Kumbakonam
  172: "Thanjavur", // Papanasam
  173: "Thanjavur", // Thiruvaiyaru
  174: "Thanjavur", // Thanjavur
  175: "Thanjavur", // Orathanadu
  176: "Thanjavur", // Pattukkottai
  177: "Thanjavur", // Peravurani
  178: "Pudukkottai", // Gandarvakottai
  179: "Pudukkottai", // Viralimalai
  180: "Pudukkottai", // Pudukkottai
  181: "Pudukkottai", // Thirumayam
  182: "Pudukkottai", // Alangudi
  183: "Pudukkottai", // Aranthangi
  184: "Sivaganga", // Karaikudi
  185: "Sivaganga", // Tiruppattur
  186: "Sivaganga", // Sivaganga
  187: "Sivaganga", // Manamadurai
  188: "Madurai", // Melur
  189: "Madurai", // Madurai East
  190: "Madurai", // Sholavandan
  191: "Madurai", // Madurai North
  192: "Madurai", // Madurai South
  193: "Madurai", // Madurai Central
  194: "Madurai", // Madurai West
  195: "Madurai", // Thiruparankundram
  196: "Madurai", // Thirumangalam
  197: "Madurai", // Usilampatti
  198: "Theni", // Andipatti
  199: "Theni", // Periyakulam
  200: "Theni", // Bodinayakanur
  201: "Theni", // Cumbum
  202: "Virudhunagar", // Rajapalayam
  203: "Virudhunagar", // Srivilliputhur
  204: "Virudhunagar", // Sattur
  205: "Virudhunagar", // Sivakasi
  206: "Virudhunagar", // Virudhunagar
  207: "Virudhunagar", // Aruppukkottai
  208: "Virudhunagar", // Tiruchuli
  209: "Ramanathapuram", // Paramakudi
  210: "Ramanathapuram", // Tiruvadanai
  211: "Ramanathapuram", // Ramanathapuram
  212: "Ramanathapuram", // Mudukulathur
  213: "Thoothukudi", // Vilathikulam
  214: "Thoothukudi", // Thoothukudi
  215: "Thoothukudi", // Tiruchendur
  216: "Thoothukudi", // Srivaikuntam
  217: "Thoothukudi", // Ottapidaram
  218: "Thoothukudi", // Kovilpatti
  219: "Tenkasi", // Sankarankovil
  220: "Tenkasi", // Vasudevanallur
  221: "Tenkasi", // Kadayanallur
  222: "Tenkasi", // Tenkasi
  223: "Tenkasi", // Alangulam
  224: "Tirunelveli", // Tirunelveli
  225: "Tirunelveli", // Ambasamudram
  226: "Tirunelveli", // Palayamkottai
  227: "Tirunelveli", // Nanguneri
  228: "Tirunelveli", // Radhapuram
  229: "Kanniyakumari", // Kanniyakumari
  230: "Kanniyakumari", // Nagercoil
  231: "Kanniyakumari", // Colachel
  232: "Kanniyakumari", // Padmanabhapuram
  233: "Kanniyakumari", // Vilavancode
  234: "Kanniyakumari" // Killiyoor
};

export const districtColors = {
  Thiruvallur: "#6C5CE7",
  Chennai: "#FD79A8",
  Chengalpattu: "#00CEC9",
  Kancheepuram: "#0984E3",
  Ranipet: "#E17055",
  Vellore: "#00B894",
  Tirupattur: "#FDCB6E",
  Krishnagiri: "#E84393",
  Dharmapuri: "#A29BFE",
  Tiruvannamalai: "#55EFC4",
  Villupuram: "#74B9FF",
  Kallakurichi: "#FF7675",
  Salem: "#FFEAA7",
  Namakkal: "#81ECEC",
  Erode: "#DFE6E9",
  Tiruppur: "#B2BEC3",
  "The Nilgiris": "#2ECC71",
  Coimbatore: "#3498DB",
  Dindigul: "#E74C8B",
  Karur: "#F39C12",
  Tiruchirappalli: "#1ABC9C",
  Perambalur: "#9B59B6",
  Ariyalur: "#E67E22",
  Cuddalore: "#5DADE2",
  Mayiladuthurai: "#48C9B0",
  Nagapattinam: "#AF7AC5",
  Tiruvarur: "#F1948A",
  Thanjavur: "#85C1E9",
  Pudukkottai: "#76D7C4",
  Sivaganga: "#F0B27A",
  Madurai: "#D35400",
  Theni: "#AED6F1",
  Virudhunagar: "#A3E4D7",
  Ramanathapuram: "#D7BDE2",
  Thoothukudi: "#F5B041",
  Tenkasi: "#82E0AA",
  Tirunelveli: "#F1C40F",
  Kanniyakumari: "#EC7063"
};

export const constituencyNames = {
  1: "கும்மிடிப்பூண்டி",
  2: "பொன்னேரி - தனி",
  3: "திருத்தணி",
  4: "திருவள்ளூர்",
  5: "பூவிருந்தவல்லி - தனி",
  6: "ஆவடி",
  7: "மதுரவாயல்",
  8: "அம்பத்தூர்",
  9: "மாதவரம்",
  10: "திருவெற்றியூர்",
  11: "மருத்துவர்.ராதாகிருஷ்ணன் நகர்",
  12: "பெரம்பூர்",
  13: "கொளத்தூர்",
  14: "வில்லிவாக்கம்",
  15: "திரு.வி.க.நகர் - தனி",
  16: "எழும்பூர் - தனி",
  17: "ராயபுரம்",
  18: "துறைமுகம்",
  19: "சேப்பாக்கம் – திருவல்லிகேனி",
  20: "ஆயிரம் விளக்கு",
  21: "அண்ணாநகர்",
  22: "விருகம்பாக்கம்",
  23: "சைதாப்பேட்டை",
  24: "தியாகராயநகர்",
  25: "மயிலாப்பூர்",
  26: "வேளச்சேரி",
  27: "சோழிங்கநல்லூர்",
  28: "ஆலந்தூர்",
  29: "ஸ்ரீபெரும்புதூர் - தனி",
  30: "பல்லாவரம்",
  31: "தாம்பரம்",
  32: "செங்கல்பட்டு",
  33: "திருப்போரூர்",
  34: "செய்யூர் - தனி",
  35: "மதுராந்தகம் - தனி",
  36: "உத்திரமேரூர்",
  37: "காஞ்சிபுரம்",
  38: "அரக்கோணம் - தனி",
  39: "சோளிங்கர்",
  40: "காட்பாடி",
  41: "இராணிப்பேட்டை",
  42: "ஆற்காடு",
  43: "வேலூர்",
  44: "அணைக்கட்டு",
  45: "கீழ்வைத்தியனான்குப்பம் - தனி",
  46: "குடியாத்தம் - தனி",
  47: "வாணியம்பாடி",
  48: "ஆம்பூர்",
  49: "ஜோலார்பேட்டை",
  50: "திருப்பத்தூர்",
  51: "ஊத்தங்கரை - தனி",
  52: "பர்கூர்",
  53: "கிருஷ்ணகிரி",
  54: "வேப்பனஹள்ளி",
  55: "ஓசூர்",
  56: "தளி",
  57: "பாலக்கோடு",
  58: "பென்னாகரம்",
  59: "தர்மபுரி",
  60: "பாப்பிரெட்டிபட்டி",
  61: "அரூர் - தனி",
  62: "செங்கம் - தனி",
  63: "திருவண்ணாமலை",
  64: "கீழ்பென்னாத்தூர்",
  65: "கலசபாக்கம்",
  66: "போளூர்",
  67: "ஆரணி",
  68: "செய்யார்",
  69: "வந்தவாசி - தனி",
  70: "செஞ்சி",
  71: "மயிலம்",
  72: "திண்டிவனம் - தனி",
  73: "வானூர் - தனி",
  74: "விழுப்புரம்",
  75: "விக்கிரவாண்டி",
  76: "திருக்கோயிலூர்",
  77: "உளுந்தூர்பேட்டை",
  78: "ரிஷிவந்தியம்",
  79: "சங்கராபுரம்",
  80: "கள்ளக்குறிச்சி - தனி",
  81: "கெங்கவல்லி - தனி",
  82: "ஆத்தூர் - தனி",
  83: "ஏற்காடு - தனி/ST",
  84: "ஓமலூர்",
  85: "மேட்டூர்",
  86: "எடப்பாடி",
  87: "சங்ககிரி",
  88: "சேலம்-மேற்கு",
  89: "சேலம்-வடக்கு",
  90: "சேலம்-தெற்கு",
  91: "வீரபாண்டி",
  92: "இராசிபுரம் - தனி",
  93: "சேந்தமங்கலம் - தனி/ST",
  94: "நாமக்கல்",
  95: "பரமத்தி வேலூர்",
  96: "திருச்செங்கோடு",
  97: "குமாரபாளையம்",
  98: "ஈரோடு - கிழக்கு",
  99: "ஈரோடு - மேற்கு",
  100: "மொடக்குறிச்சி",
  101: "தாராபுரம் - தனி",
  102: "காங்கேயம்",
  103: "பெருந்துறை",
  104: "பவானி",
  105: "அந்தியூர்",
  106: "கோபிசெட்டிபாளையம்",
  107: "பவானிசாகர் - தனி",
  108: "உதகமண்டலம்",
  109: "கூடலூர் - தனி",
  110: "குன்னூர்",
  111: "மேட்டுப்பாளையம்",
  112: "அவினாசி - தனி",
  113: "திருப்பூர் வடக்கு",
  114: "திருப்பூர் தெற்கு",
  115: "பல்லடம்",
  116: "சூலூர்",
  117: "கவுண்டம்பாளையம்",
  118: "கோயம்புத்தூர் வடக்கு",
  119: "தொண்டாமுத்தூர்",
  120: "கோயம்புத்தூர் தெற்கு",
  121: "சிங்காநல்லூர்",
  122: "கிணத்துக்கடவு",
  123: "பொள்ளாச்சி",
  124: "வால்பாறை - தனி",
  125: "உடுமலைப்பேட்டை",
  126: "மடத்துக்குளம்",
  127: "பழனி",
  128: "ஒட்டன்சத்திரம்",
  129: "ஆத்தூர்",
  130: "நிலக்கோட்டை - தனி",
  131: "நத்தம்",
  132: "திண்டுக்கல்",
  133: "வேடசந்தூர்",
  134: "அரவக்குறிச்சி",
  135: "கரூர்",
  136: "கிருஷ்ணராயபுரம் - தனி",
  137: "குளித்தலை",
  138: "மணப்பாறை",
  139: "திருவரங்கம்",
  140: "திருச்சிராப்பள்ளி மேற்கு",
  141: "திருச்சிராப்பள்ளி கிழக்கு",
  142: "திருவெறும்பூர்",
  143: "இலால்குடி",
  144: "மண்ணச்சநல்லூர்",
  145: "முசிறி",
  146: "துறையூர் - தனி",
  147: "பெரம்பலூர் - தனி",
  148: "குன்னம்",
  149: "அரியலூர்",
  150: "ஜெயங்கொண்டம்",
  151: "திட்டக்குடி - தனி",
  152: "விருத்தாசலம்",
  153: "நெய்வேலி",
  154: "பண்ருட்டி",
  155: "கடலூர்",
  156: "குறிஞ்சிப்பாடி",
  157: "புவனகிரி",
  158: "சிதம்பரம்",
  159: "காட்டுமண்ணார்கோயில் - தனி",
  160: "சீர்காழி - தனி",
  161: "மயிலாடுதுறை",
  162: "பூம்புகார்",
  163: "நாகப்பட்டினம்",
  164: "கீழ்வேளூர் - தனி",
  165: "வேதாரண்யம்",
  166: "திருத்துறைப்பூண்டி - தனி",
  167: "மன்னார்குடி",
  168: "திருவாரூர்",
  169: "நன்னிலம்",
  170: "திருவிடைமருதூர் - தனி",
  171: "கும்பகோணம்",
  172: "பாபநாசம்",
  173: "திருவையாறு",
  174: "தஞ்சாவூர்",
  175: "ஒரத்தநாடு",
  176: "பட்டுக்கோட்டை",
  177: "பேராவூரணி",
  178: "கந்தர்வக்கோட்டை - தனி",
  179: "விராலிமலை",
  180: "புதுக்கோட்டை",
  181: "திருமயம்",
  182: "ஆலங்குடி",
  183: "அறந்தாங்கி",
  184: "காரைக்குடி",
  185: "திருப்பத்தூர்",
  186: "சிவகங்கை",
  187: "மானாமதுரை - தனி",
  188: "மேலூர்",
  189: "மதுரை கிழக்கு",
  190: "சோழவந்தான் - தனி",
  191: "மதுரை வடக்கு",
  192: "மதுரை தெற்கு",
  193: "மதுரை மத்தியம்",
  194: "மதுரை மேற்கு",
  195: "திருப்பரங்குன்றம்",
  196: "திருமங்கலம்",
  197: "உசிலம்பட்டி",
  198: "ஆண்டிப்பட்டி",
  199: "பெரியகுளம் - தனி",
  200: "போடிநாயக்கனூர்",
  201: "கம்பம்",
  202: "இராஜபாளையம்",
  203: "திருவில்லிபுத்தூர் - தனி",
  204: "சாத்தூர்",
  205: "சிவகாசி",
  206: "விருதுநகர்",
  207: "அருப்புக்கோட்டை",
  208: "திருச்சுழி",
  209: "பரமக்குடி - தனி",
  210: "திருவாடானை",
  211: "இராமநாதபுரம்",
  212: "முதுகுளத்தூர்",
  213: "விளாத்திகுளம்",
  214: "தூத்துக்குடி",
  215: "திருச்செந்தூர்",
  216: "ஸ்ரீவைகுண்டம்",
  217: "ஓட்டப்பிடாரம் - தனி",
  218: "கோவில்பட்டி",
  219: "சங்கரன்கோவில் - தனி",
  220: "வாசுதேவநல்லூர் - தனி",
  221: "கடையநல்லூர்",
  222: "தென்காசி",
  223: "ஆலங்குளம்",
  224: "திருநெல்வேலி",
  225: "அம்பாசமுத்திரம்",
  226: "பாளையங்கோட்டை",
  227: "நாங்குநேரி",
  228: "இராதாபுரம்",
  229: "கன்னியாகுமரி",
  230: "நாகர்கோவில்",
  231: "குளச்சல்",
  232: "பத்மனாபபுரம்",
  233: "விளவங்கோடு",
  234: "கிள்ளியூர்"
};

export const constituencyUrls = {
  1: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gummidipoondi",
  2: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ponneri-sc",
  3: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruttani",
  4: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvallur",
  5: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ponnamallee-sc",
  6: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/avadi",
  7: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madhuravoyal",
  8: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambattur",
  9: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madhavaram",
  10: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvottiyur",
  11: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dr-radhakrishnan-nagar",
  12: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perambur",
  13: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kolathur",
  14: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/villivakkam",
  15: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiru-vi-ka-nagar",
  16: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/egmore-sc",
  17: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/royapuram",
  18: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/harbour",
  19: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chepauk-thiruvallikeni",
  20: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thousand-lights",
  21: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anna-nagar",
  22: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/virugampakkam",
  23: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/saidapet",
  24: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiyagarayanagar",
  25: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mylapore",
  26: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/velachery",
  27: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/shozhinganallur",
  28: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alandur",
  29: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sriperumbudur-sc",
  30: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pallavaram",
  31: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tambaram",
  32: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chengalpattu",
  33: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruporur",
  34: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cheyyur-sc",
  35: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/maduranthakam-sc",
  36: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/uthiramerur",
  37: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kanchipuram",
  38: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arakkonam-sc",
  39: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sholinghur",
  40: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/katpadi",
  41: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ranipet",
  42: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arcot",
  43: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vellore",
  44: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anaikattu",
  45: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilvaithinankuppam-sc",
  46: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gudiyattam-sc",
  47: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vaniyambadi",
  48: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambur",
  49: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/jolarpet",
  50: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirupathur",
  51: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/uthangarai-sc",
  52: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bargur",
  53: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/krishnagiri",
  54: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/veppanahalli",
  55: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/hosur",
  56: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thali",
  57: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palacodu",
  58: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pennagaram",
  59: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dharmapuri",
  60: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pappireddipatti",
  61: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/harur-sc",
  62: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chengam",
  63: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvannamalai",
  64: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilpennathur",
  65: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kalasapakkam",
  66: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/polur",
  67: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/arni",
  68: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cheyyar",
  69: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vandavasi",
  70: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gingee",
  71: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mailam",
  72: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tindivanam-sc",
  73: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vanur-sc",
  74: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/viluppuram",
  75: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vikkaravandi",
  76: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirukkoyilur",
  77: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ulundurpettai",
  78: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rishivandiyam",
  79: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankarapuram",
  80: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kallakurichi-sc",
  81: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gangavalli-sc",
  82: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/attur-sc",
  83: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/yercaud-st",
  84: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/omalur",
  85: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mettur",
  86: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/edappadi",
  87: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankari",
  88: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-west",
  89: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-north",
  90: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/salem-south",
  91: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/veerapandi",
  92: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rasipuram-sc",
  93: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/senthamangalam-st",
  94: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/namakkal",
  95: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/paramathi-velur",
  96: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchengode",
  97: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kumarapalayam",
  98: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/erode-east",
  99: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/erode-west",
  100: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/modakkurichi",
  101: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dharapuram-sc",
  102: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kangeyam",
  103: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perundurai",
  104: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhavani",
  105: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/anthiyur",
  106: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gobichettipalayam",
  107: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhavanisagar-sc",
  108: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/udhagamandalam",
  109: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gudalur-sc",
  110: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coonoor",
  111: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mettuppalayam",
  112: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/avanashi-sc",
  113: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruppur-north",
  114: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruppur-south",
  115: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palladam",
  116: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sulur",
  117: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kavundampalayam",
  118: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coimbatore-north",
  119: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thondamuthur",
  120: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/coimbatore-south",
  121: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/singanalur",
  122: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kinathukadavu",
  123: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pollachi",
  124: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/valparai-sc",
  125: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/udumalaipettai",
  126: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madathukulam",
  127: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palani",
  128: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/oddenchatram",
  129: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/athoor",
  130: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nilakkottai",
  131: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/natham",
  132: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/dindigul",
  133: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vedasandur",
  134: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aravakaurichi",
  135: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/karur",
  136: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/krishnarayapuram-sc",
  137: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kulithalai",
  138: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manapparai",
  139: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srirangam",
  140: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchirappalli-west",
  141: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchirappalli-east",
  142: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruverumbur",
  143: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/lalgudi",
  144: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manachanallur",
  145: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/musiri",
  146: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thuraiyur-sc",
  147: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/perambalur-sc",
  148: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kunnam",
  149: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ariyalur",
  150: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/jayankondam",
  151: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tittakudi-sc",
  152: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vridhachalam",
  153: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/neyveli",
  154: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/panruti",
  155: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cuddalore",
  156: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kurinjipadi",
  157: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bhuvanagiri",
  158: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/chidambaram",
  159: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kattumannarkoil-sc",
  160: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sirkali-sc",
  161: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mayiladuthurai",
  162: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/poompuhar",
  163: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nagapattinam",
  164: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kilvelur-sc",
  165: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vedaranyam",
  166: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruthuraipoondi-sc",
  167: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mannargudi",
  168: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvarur",
  169: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nannilam",
  170: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvidaimarudur-sc",
  171: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kumbakonam",
  172: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/papanasam",
  173: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruvaiyaru",
  174: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thanjavur",
  175: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/orathanadu",
  176: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pattukkottai",
  177: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/peravurani",
  178: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/gandharvakottai-sc",
  179: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/viralimalai",
  180: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/pudukkottai",
  181: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thirumayam",
  182: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alangudi",
  183: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aranthangi",
  184: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/karaikudi",
  185: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirupathur",
  186: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sivagangai",
  187: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/manamadurai-sc",
  188: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/melur",
  189: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-east",
  190: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sholavandan-sc",
  191: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-north",
  192: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-south",
  193: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-central",
  194: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/madurai-west",
  195: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thiruparankundram",
  196: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thirumangalam",
  197: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/usilampatti",
  198: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/andipatti",
  199: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/periakulam-sc",
  200: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/bodinayakanur",
  201: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/cumbum",
  202: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/rajapalayam",
  203: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srivilliputhur-sc",
  204: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sattur",
  205: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sivakasi",
  206: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/virudhunagar",
  207: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/aruppukottai",
  208: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchuli",
  209: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/paramakudi-sc",
  210: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruvadanai",
  211: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ramanathapuram",
  212: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/mudukulathur",
  213: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vilathikulam",
  214: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/thoothukudi",
  215: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tiruchendur",
  216: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/srivaikundam",
  217: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ottapidaram",
  218: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kovilpatti",
  219: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/sankarankovil",
  220: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vasudevanallur-sc",
  221: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kadayanallur",
  222: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tenkasi",
  223: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/alangulam",
  224: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/tirunelveli",
  225: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/ambasamudram",
  226: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/palayamkottai",
  227: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nanguneri",
  228: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/radhapuram",
  229: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/kanyakumari",
  230: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/nagercoil",
  231: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/colachel",
  232: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/padmanabhapuram",
  233: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/vilavancode",
  234: "https://www.vikatan.com/election/tn-assembly-election-2026/constituency/killiyoor"
};
